import React, { Component } from "react";
import {
  View,
  Text,
  TextInput,
  Button,
  Platform,
  Keyboard,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
} from "react-native";
import textConstants from "../../constants/textConstants";
import Accordion from "./accordian";
import styles from "./styles.js";
import RadioButton from "../../commonComponents/radioButtonComponent";
import chatstyles from "../../styles/chatStyles";
import KeyboardAwareScrollView from "../KeyboardAwareScrollView";
import Header from "../../commonComponents/Header.js";
import CommonButton from "../../commonComponents/Button.js";
import HocComponent from "../../commonComponents/Hoc";
import { decrypt } from "../../utils/encryption";
import {
  createCreateDebitCardInputs,
  createInternetBankingInputs,
  renderPaynowBtn,
} from "./functions";
import { OTP_PAYMENT } from "../../constants/routePaths";
const regexOnlyNumber = /^[0-9 ]+$/;

const regexOnlyTextNumber = /^[a-zA-Z. ]+$/;

class PaymentScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBank: "",
      CloseOpenDebitCard: false,
      CloseOpenInternetBanking: false,
      whatsappid: "",
      scrolltobottom: false,
      current_room: "",
      fareAmount: "",
      customerId: "",
      redirect: "",
      vals: "",
      elements_profile: [
        {
          name: textConstants.debitCreditCard,
          imageUrl: require("../../../assets/images/debitcreditcard.png"),
          childrenArr: [
            {
              type: "text",
              placeholder: textConstants.cardNumber,
              name: textConstants.cardNumber,
              errorMsg: textConstants.cardNumberErrorMsg,
              correct: true,
              value: "",
              visible: true,
              maxLength: 19,
              keyboardType: "numeric",
            },
            {
              type: "text",
              placeholder: textConstants.nameOnCard,
              name: textConstants.nameOnCard,
              errorMsg: textConstants.nameOnCardErrorMsg,
              correct: true,
              value: "",
              visible: true,
              maxLength: 20,
              keyboardType: "default",
            },
            {
              type: "text",
              placeholder: textConstants.expiry,
              name: textConstants.expiry,
              errorMsg: textConstants.expiryErrorMsg,
              correct: true,
              value: "",
              visible: true,
              maxLength: 5,
              keyboardType: "numeric",
            },
            {
              type: "text",
              placeholder: textConstants.CVV,
              name: textConstants.CVV,
              errorMsg: textConstants.cvvErrorMsg,
              correct: true,
              value: "",
              visible: true,
              maxLength: 3,
              keyboardType: "numeric",
            },
          ],
        },

        {
          name: textConstants.internetBanking,
          imageUrl: require("../../../assets/images/internetBanking.png"),
          childrenArr: [
            {
              type: "text",
              placeholder: "Customer Name*",
              name: "Customer Name",
              errorMsg: "Please enter valid Customer Name",
              correct: true,
              value: "",
              visible: true,
              maxLength: 100,
              keyboardType: "default",
            },
            {
              type: "dropdown",
              placeholder: "Bank Name*",
              name: "Bank Name",
              errorMsg: "Please enter valid Bank Name",
              correct: true,
              value: "",
              visible: true,
              maxLength: 100,
              keyboardType: "default",
              bankArray: ["Bank1", "Bank2", "Bank3", "Bank4", "Bank5"],
              enableDefaultValue: true,
            },
            {
              type: "text",
              placeholder: "Please enter 16 digit Account Number*",
              name: "Account Number",
              errorMsg: "Please enter valid Account Number",
              correct: true,
              value: "",
              visible: true,
              maxLength: 19,
              keyboardType: "numeric",
            },
            {
              type: "text",
              placeholder: "Please enter 6 digit Routing/Sort Code*",
              name: "Sort Code",
              errorMsg: "Please enter valid Sort Code",
              correct: true,
              value: "",
              visible: true,
              maxLength: 8,
              keyboardType: "numeric",
            },
          ],
        },
      ],
    };
  }

  async componentDidMount() {
    let urlData;
    if (Platform.OS === "web") {
      let encrypteddata = window.location.search.replace("?data=", "");
      urlData = JSON.parse(decrypt(encrypteddata));
    } else {
      // get encrypted data for mbl
      const encrypteddata = this.props.route.params["data"];
      urlData = JSON.parse(decrypt(encrypteddata));
    }

    this.setState({
      customerId: urlData.Id,
      redirect: urlData.No ? process.env.WHATSAPP_LINK + urlData.No : false,
      fareAmount: parseFloat(urlData.Amt).toFixed(2),
    });
  }

  componentWillMount() {
    this.keyboardDidShowListener = Keyboard.addListener(
      "keyboardDidShow",
      this._keyboardDidShow.bind(this)
    );
    this.keyboardDidHideListener = Keyboard.addListener(
      "keyboardDidHide",
      this._keyboardDidHide.bind(this)
    );
  }

  componentWillUnmount() {
    this.keyboardDidShowListener.remove();
    this.keyboardDidHideListener.remove();
  }
  //show scroll view
  _keyboardDidShow() {
    this.setState({
      scrolltobottom: true,
    });
  }
  //hide scroll view
  _keyboardDidHide() {
    this.setState({
      scrolltobottom: false,
    });
  }
  //handling debit/credit card text input change
  textInputChange = (name, val, index, sectionName) => {
    var config = this.state.elements_profile;
    console.log(val);
    switch (name) {
      case textConstants.cardNumber:
        try {
          for (var j = 0; j < config.length; j++) {
            for (var i = 0; i < config[j].childrenArr.length; i++) {
              if (config[j].childrenArr[i].name == name) {
                if (regexOnlyNumber.test(val) || val === "") {
                  config[j].childrenArr[i].value = val
                    .replace(/\s?/g, "")
                    .replace(/(\d{4})/g, "$1 ")
                    .trim();
                  config[j].childrenArr[i].correct = true;
                } else {
                  //config[j].childrenArr[i].value = val;
                  //config[j].childrenArr[i].correct = false;
                }
              }
            }
            this.setState({ elements_profile: config });
          }
        } catch (err) {}
        break;
      case textConstants.nameOnCard:
        try {
          for (var j = 0; j < config.length; j++) {
            for (var i = 0; i < config[j].childrenArr.length; i++) {
              if (config[j].childrenArr[i].name == name) {
                console.log(val);
                if (regexOnlyTextNumber.test(val) || val === "") {
                  config[j].childrenArr[i].value = val;
                  config[j].childrenArr[i].correct = true;
                } else {
                  //config[j].childrenArr[i].value = val;
                  //config[j].childrenArr[i].correct = false;
                }
              }
            }
            this.setState({ elements_profile: config });
          }
        } catch (err) {}
        break;

      case textConstants.expiry:
        try {
          let d = new Date();
          let month = d.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          let y = d.getFullYear();
          let shortyear = y.toString().substr(-2);
          let textTemp = val.replace(/[^0-9.\/]/g, "");
          for (var j = 0; j < config.length; j++) {
            for (var i = 0; i < config[j].childrenArr.length; i++) {
              if (config[j].childrenArr[i].name == name) {
                //if (regexOnlyNumber.test(textTemp)) {
                if (textTemp[0] !== "1" && textTemp[0] !== "0") {
                  textTemp = "";
                }
                if (
                  textTemp.length === 2 &&
                  config[j].childrenArr[i].value.length == 1
                ) {
                  if (
                    parseInt(textTemp.substring(0, 2)) > 12 ||
                    parseInt(textTemp.substring(0, 2)) == 0
                  ) {
                    textTemp = textTemp[0];
                  } else if (textTemp.length === 2) {
                    textTemp += "/";
                  } else {
                    textTemp = textTemp[0];
                  }
                }
                if (textTemp.length === 5) {
                  if (
                    parseInt(textTemp.substring(3, 5)) < shortyear ||
                    (parseInt(textTemp.substring(0, 2)) < month &&
                      parseInt(textTemp.substring(3, 5)) <= shortyear)
                  ) {
                    textTemp = "";
                  }
                }
                if (textTemp && textTemp.length >= 1) {
                  config[j].childrenArr[i].value = textTemp;
                  config[j].childrenArr[i].correct = true;
                } else {
                  config[j].childrenArr[i].value = textTemp;
                  config[j].childrenArr[i].correct = false;
                }
                // }
              }
            }
            this.setState({ elements_profile: config });
          }

          this.setState({ elements_profile: config });
        } catch (err) {}

        break;
      case textConstants.CVV:
        try {
          for (var j = 0; j < config.length; j++) {
            for (var i = 0; i < config[j].childrenArr.length; i++) {
              if (config[j].childrenArr[i].name == name) {
                if (regexOnlyNumber.test(val) || val === "") {
                  config[j].childrenArr[i].value = val;
                  config[j].childrenArr[i].correct = true;
                } else {
                  //config[j].childrenArr[i].value = val;
                  //config[j].childrenArr[i].correct = false;
                }
              }
            }
            this.setState({ elements_profile: config });
          }
        } catch (err) {}
        break;
    }
  };
  //show selected radio button & bank name
  selectedRadioBtn = async (val) => {
    var config = this.state.elements_profile;
    for (var j = 0; j < config.length; j++) {
      for (var i = 0; i < config[j].childrenArr.length; i++) {
        if (config[j].childrenArr[i].name === textConstants.internetBanking) {
          config[j].childrenArr[i].value = await val;
          config[j].childrenArr[i].correct = await true;
        }
      }
    }
    await this.setState({ elements_profile: config, selectedBank: val });

    console.log(this.state.elements_profile);
  };

  // Open or close payment options on clicking toggle icon
  onClickTabs = (title) => {
    if (title == "Debit/Credit Card") {
      this.setState({
        CloseOpenDebitCard: !this.state.CloseOpenDebitCard,
        CloseOpenInternetBanking: false,
      });
    } else {
      this.setState({
        CloseOpenInternetBanking: !this.state.CloseOpenInternetBanking,
        CloseOpenDebitCard: false,
      });
    }
  };

  onPressButton = (data) => {
    let dataToPass = {
      customerId: this.state.customerId,
      fareAmount: this.state.fareAmount,
      debitCardNumber: this.state.elements_profile[0].childrenArr[0].value,
      redirect: this.state.redirect,
    };
    this.setState({ elements_profile: data.configData });
    if (data.debitCard && data.valid) {
      if (Platform.OS != "web") {
        this.props.navigation.navigate(OTP_PAYMENT, { state: dataToPass });
      } else {
        this.props.history.push({
          pathname: OTP_PAYMENT,
          state: dataToPass,
        });
      }
    } else if (data.internetBanking && data.valid) {
      let dataToPass = {
        customerId: this.state.customerId,
        fareAmount: this.state.fareAmount,
        debitCardNumber: data.accountNumber,
        redirect: this.state.redirect,
      };
      if (Platform.OS != "web") {
        this.props.navigation.navigate(OTP_PAYMENT, {
          state: dataToPass,
        });
      } else {
        console.log("PROPS", this.props);

        this.props.history.push({
          pathname: OTP_PAYMENT,
          state: dataToPass,
        });
      }
    }
  };

  //payment page UI rendering
  render() {
    const outerViewResposive = `outerViewResposive_${this.props.measure}`;
    const config = this.state.elements_profile;
    return (
      <SafeAreaView style={styles.safeAreaViewStyle}>
        <Header
          showHeader={Platform.OS == "web" ? true : false}
          headerText="Payment Gateway"
        />

        <View style={styles.safeAreaViewChild}>
          <View style={[styles.outerView, styles[outerViewResposive]]}>
            <KeyboardAwareScrollView>
              <ScrollView
                showsVerticalScrollIndicator={false}
                contentContainerStyle={[
                  this.state.scrolltobottom
                    ? chatstyles.contentContainer
                    : chatstyles.contentonkeyboard,
                ]}
                ref={(ref) => (this.scrollView = ref)}
                onContentSizeChange={(contentWidth, contentHeight) => {
                  this.scrollView.scrollToEnd({ animated: true });
                }}
              >
                <View style={styles.paymentHeadingView}>
                  <Text style={styles.paymentHeading}>
                    {textConstants.paymentHeading}
                  </Text>
                  <Text style={styles.paymentSubHeading}>
                    {textConstants.paymentSubHeading}
                  </Text>

                  <Text style={styles.paymentAmounttxt}>
                    Total Amount is{" "}
                    <Text
                      style={
                        Platform.OS === "ios"
                          ? { fontFamily: "SFProTextBold", fontWeight: "bold" }
                          : styles.amountBold
                      }
                    >
                      £{this.state.fareAmount}
                    </Text>
                  </Text>
                </View>

                <View style={styles.mainExpandableView}>
                  {config.map((item, index) => {
                    return (
                      <View
                        key={index}
                        nativeID={`accordian_${index}`}
                        style={
                          index === config.length - 1
                            ? styles.accordianWithNoBorder
                            : styles.accordianWithBorder
                        }
                      >
                        <View>
                          <Accordion
                            onClickTabs={this.onClickTabs}
                            title={item.name}
                            imgUrl={item.imageUrl}
                            imgStyles={styles.accordianImg}
                            accordianHead={styles.accordianHead}
                            accordianText={styles.accordianText}
                            arrowMark={styles.arrowMark}
                            iconText={styles.iconText}
                            toggleIconWidth={styles.toggleIconWidth}
                            CloseOpenDebitCard={this.state.CloseOpenDebitCard}
                            CloseOpenInternetBanking={
                              this.state.CloseOpenInternetBanking
                            }
                          >
                            <View style={styles.paymentTextInputView}>
                              {item.name === textConstants.debitCreditCard &&
                                this.state.CloseOpenDebitCard &&
                                createCreateDebitCardInputs(
                                  this.state.elements_profile,
                                  this.textInputChange
                                )}

                              {item.name === textConstants.internetBanking &&
                                this.state.CloseOpenInternetBanking &&
                                createInternetBankingInputs(
                                  this.state.elements_profile,
                                  this.state.selectedBank,
                                  this.onPressButton
                                )}
                            </View>
                            <View style={styles.paddingBottom15}>
                              {item.name === textConstants.debitCreditCard &&
                                this.state.CloseOpenDebitCard &&
                                renderPaynowBtn(
                                  item.name,
                                  this.state.elements_profile,
                                  this.onPressButton
                                )}
                              {/* {item.name === textConstants.internetBanking &&
                                this.state.CloseOpenInternetBanking &&
                                renderPaynowBtn(
                                  item.name,
                                  this.state.elements_profile,
                                  this.onPressButton
                                )} */}
                            </View>
                          </Accordion>
                        </View>
                      </View>
                    );
                  })}
                </View>
              </ScrollView>
            </KeyboardAwareScrollView>
          </View>
        </View>
      </SafeAreaView>
    );
  }
}
export default HocComponent(PaymentScreen);
